<div class="card dialog-box">
  <div class="card-header">
    Report Schedule
    <span class="float-end" (click)="closeDialog()">
      <i class="fa-solid fa-xmark"></i>
    </span>
  </div>
  <div class="p-2">
    @if (reportStep === 1) {
      <div class="d-flex flex-column gap-2 mb-3">
        <div class="form-floating d-none">
          <input
            class="form-control"
            type="text"
            [(ngModel)]="newReportData.name"
            placeholder="Report Name"
          />
          <label>Report Name</label>
        </div>
        <div class="form-floating">
          <input
            class="form-control"
            type="time"
            placeholder="Send Report At"
            (change)="roundDateTimeToQuarterHour($event)"
            [ngModel]="newReportData?.mail_time"
          />
          <label>Send Report At</label>
        </div>
      </div>
      <div class="row d-flex gap-2 offset-6">
        <button
          type="button"
          class="btn btn-primary btn-lg w-100"
          [disabled]="!newReportData.mail_time"
          (click)="reportStep = 2"
        >
          Next
        </button>
      </div>
    }
    @if (reportStep === 2) {
      <div class="d-flex flex-column gap-2 mb-3">
        <div class="border rounded p-2 mb-3">
          <dl>
            <dt>Job Types</dt>
            <dd>
              <div class="p-2 mb-2">
                Select the job types for this schedule.
              </div>
              <div class="d-flex flex-wrap gap-4">
                @for (jobType of jobTypesDataList; track $index) {
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      [checked]="jobType?.is_selected"
                      (change)="jobType.is_selected = !jobType?.is_selected"
                      id="check-{{ jobType?.id }}"
                    />
                    <label
                      class="form-check-label"
                      for="check-{{ jobType?.id }}"
                    >
                      {{ jobType?.name }}
                    </label>
                  </div>
                }
              </div>
            </dd>
          </dl>
        </div>

        <div class="border rounded p-2 mb-3">
          <dl>
            <div class="d-flex gap-2 align-items-center mb-2">
              <div class="flex-grow-1">
                <dt>{{ addSites ? "Sites" : "Client" }}</dt>
              </div>

              @if (addSites) {
                <div
                  (click)="
                    addSites = false;
                    newReportData.company_data = [{}];
                    newReportData.site_data = [{}]
                  "
                  class="py-1 px-2 border rounded small hover bg-primary"
                  role="button"
                >
                  <div>Setup for Client(s)</div>
                </div>
              }

              @if (!addSites) {
                <div
                  (click)="
                    addSites = true;
                    newReportData.company_data = [{}];
                    newReportData.site_data = [{}]
                  "
                  class="py-1 px-2 border rounded small hover bg-primary"
                  role="button"
                >
                  <div>Setup for Site(s)</div>
                </div>
              }
            </div>

            @if (addSites) {
              <div class="p-2 mb-2">
                Reports will be sent to the following site(s) at
                <span class="fw-semibold"> {{ newReportData?.mail_time }}</span>
                for any completed jobs matching the selected job types above.
              </div>
              @for (
                siteInfo of newReportData?.site_data;
                track $index;
                let i = $index
              ) {
                @if (siteInfo?.id) {
                  <ul>
                    <li>
                      <dl class="px-2 px-md-4">
                        <div class="d-flex align-items-center">
                          <div class="flex-grow-1">
                            <dd
                              (click)="
                                editField('site');
                                newReportData?.site_data?.splice(i, 1)
                              "
                              class="link-edit"
                            >
                              {{ siteInfo?.company_name }}
                              @if (siteInfo?.company?.company_name) {
                                <span>
                                  [{{ siteInfo?.company?.company_name }}]
                                </span>
                              }
                            </dd>
                          </div>
                        </div>
                      </dl>
                    </li>
                  </ul>
                } @else {
                  <ng-container>
                    <gtapp-auto-complete
                      [data]="siteListData"
                      placeHolder="Add Site"
                      searchKeyword="company_name"
                      [itemTemplate]="siteTemplate"
                      (inputChanged)="onSiteSearch($event)"
                      (selected)="
                        newReportData.site_data[i] = $event;
                        newReportData.site_data.push({})
                      "
                      inputId="siteId"
                      [enableCloseOption]="true"
                      (fieldCleared)="editField('site')"
                      (inputFocused)="inputFocused('site')"
                    >
                    </gtapp-auto-complete>
                    <ng-template #siteTemplate let-item>
                      <div>
                        <div class="fw-medium">
                          {{ item?.company_name }} [{{
                            item?.company?.company_name
                          }}]
                        </div>

                        <div class="small-font text-secondary">
                          {{ item?.address?.full_address }}
                        </div>
                      </div>
                    </ng-template>
                  </ng-container>
                }
              }
            } @else {
              <div class="p-2 mb-2">
                Reports will be sent to the following client(s) at
                <span class="fw-semibold"> {{ newReportData?.mail_time }}</span>
                for any completed jobs matching the selected job types above.
              </div>
              @for (
                clientInfo of newReportData?.company_data;
                track $index;
                let i = $index
              ) {
                @if (clientInfo?.id) {
                  <ul>
                    <li>
                      <dl class="px-2 px-md-4">
                        <div class="d-flex align-items-center">
                          <div class="flex-grow-1">
                            <dd
                              (click)="
                                editField('client');
                                newReportData?.company_data?.splice(i, 1)
                              "
                              class="link-edit"
                            >
                              {{ clientInfo?.company_name }}
                            </dd>
                          </div>
                        </div>
                      </dl>
                    </li>
                  </ul>
                } @else {
                  <ng-container>
                    <gtapp-auto-complete
                      (selected)="
                        newReportData.company_data[i] = $event;
                        newReportData.company_data.push({})
                      "
                      [data]="clientDropDownList"
                      placeHolder="Add Client"
                      searchKeyword="company_name"
                      [itemTemplate]="clientLookupTemplate"
                      (inputChanged)="onClientSearch($event)"
                      [enableCloseOption]="true"
                      inputId="clientLookupId"
                      (fieldCleared)="editField('client')"
                      (inputFocused)="inputFocused('client')"
                    >
                    </gtapp-auto-complete>
                    <ng-template #clientLookupTemplate let-item>
                      <div>
                        {{ item?.company_name }}
                      </div>
                    </ng-template>
                  </ng-container>
                }
              }
            }
          </dl>
        </div>
      </div>

      <div class="d-flex gap-2">
        {{
          newReportData?.company_data?.[newReportData?.company_data?.length - 1]
            ?.id
        }}
        <button
          type="button"
          class="btn btn-dark btn-lg w-100"
          (click)="reportStep = 1"
        >
          Back
        </button>
        <button
          type="button"
          class="btn btn-primary btn-lg w-100"
          [disabled]="
            newReportData?.company_data?.length < 2 &&
            newReportData?.site_data?.length < 2
          "
          (click)="reportStep = 3; checkReportRecipients(contactTemplate)"
        >
          Next
        </button>
      </div>
    }
    @if (reportStep === 3) {
      <dl>
        <dt class="mb-1">Contacts</dt>
        <div class="p-3">Reports will be sent to the following recipients.</div>

        <dd class="mb-2 d-flex flex-wrap gap-2">
          @for (
            contact of newReportData?.contacts;
            track contact;
            let i = $index
          ) {
            <div
              class="d-flex flex-column flex-wrap border rounded p-2 mb-2 shadow"
            >
              <div class="fw-semibold">
                {{ contact?.first_name }} {{ contact?.last_name }}
                <span
                  (click)="newReportData?.contacts?.splice(i, 1)"
                  role="button"
                  class="float-end"
                >
                  <i
                    class="fa-solid fa-circle-minus md-font-size text-danger"
                  ></i>
                </span>
              </div>
              <div class="d-flex mb-2 small px-1">
                {{ contact?.email }}
              </div>
            </div>
          }

          <div
            class="d-flex flex-column flex-wrap border rounded p-2 mb-2 shadow p-4"
            role="button"
            (click)="openTemplate(contactTemplate)"
          >
            <i class="fa-solid fa-plus"></i>
          </div>
        </dd>
      </dl>
      <div class="d-flex gap-2">
        <button
          type="button"
          class="btn btn-dark btn-lg w-100"
          (click)="reportStep = 2"
        >
          Back
        </button>
        <button
          type="button"
          class="btn btn-success btn-lg w-100"
          [disabled]="!newReportData?.contacts?.length"
          (click)="addScheduledReport()"
        >
          Save
        </button>
      </div>
    }
  </div>
</div>
<ng-template #contactTemplate let-contactTemplateRef="dialogRef" let-data>
  <div class="card dialog-box">
    <div class="card-header">
      Add Contacts
      <span class="float-end" (click)="contactTemplateRef.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <div>
      <div class="mb-2">
        <gtapp-auto-complete
          [data]="contactListData"
          placeHolder="Search / Select Contact"
          searchKeyword="full_name"
          [itemTemplate]="contactLookupTemplate"
          (inputChanged)="onContactSearch($event)"
          (selected)="contactTemplateRef.close($event)"
          [enableCloseOption]="true"
        >
        </gtapp-auto-complete>
        <ng-template #contactLookupTemplate let-item>
          <div>
            <div class="fw-medium">
              {{ item?.first_name }} {{ item?.last_name }}
            </div>

            <div class="small-font text-secondary">
              {{ item?.email }}
            </div>
          </div>
        </ng-template>
      </div>
      <div class="border rounded p-2">
        <div class="mb-2 fw-semibold small">New Contact</div>

        <div class="p-3">
          <form [formGroup]="contactForm" appFormEnterAction>
            <div class="row row-cols-1 g-2 mb-4">
              <div class="form-floating">
                <input
                  class="form-control"
                  type="text"
                  id="firstName"
                  (keyup.enter)="shiftFocus('lastName')"
                  formControlName="first_name"
                  autocomplete="off"
                  [maxlength]="150"
                  placeholder="First Name"
                />
                <label for="firstName">First Name</label>
              </div>

              <div class="form-floating">
                <input
                  class="form-control"
                  type="text"
                  id="lastName"
                  (keyup.enter)="shiftFocus('email')"
                  formControlName="last_name"
                  autocomplete="off"
                  [maxlength]="150"
                  placeholder="Last Name"
                />
                <label for="lastName">Last Name</label>
              </div>

              <div class="form-floating">
                <input
                  class="form-control"
                  type="email"
                  id="email"
                  [class.is-invalid]="
                    contactForm.controls['email'].invalid &&
                    contactForm.controls['email'].touched
                  "
                  (keyup.enter)="shiftFocus('phone')"
                  formControlName="email"
                  autocomplete="off"
                  placeholder="Email"
                />
                <label for="email">Email</label>
              </div>
              @if (dupContactCheck()) {
                <div>
                  <p class="text-danger">Email address already added</p>
                </div>
              }

              <div class="form-floating">
                <input
                  class="form-control"
                  type="tel"
                  inputmode="numeric"
                  pattern="[0-9]*"
                  minlength="7"
                  maxlength="10"
                  id="phone"
                  formControlName="mobile_number"
                  autocomplete="off"
                  placeholder="Telephone (Optional)"
                  (input)="mobileNumberCheck()"
                />
                <label for="phone">Telephone (Optional)</label>
                @if (
                  contactForm.controls["mobile_number"].invalid &&
                  contactForm.controls["mobile_number"].touched
                ) {
                  <div>
                    <p class="text-danger">
                      Mobile should be a 10-digit number
                    </p>
                  </div>
                }
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="row g-2 my-3">
        <div class="col">
          <button
            type="button"
            class="btn btn-lg btn-darkn-light w-100"
            (click)="contactForm.reset(); contactTemplateRef.close()"
          >
            Cancel
          </button>
        </div>
        <div class="col">
          <button
            type="button"
            class="btn btn-lg btn-primary w-100"
            [disabled]="!contactForm.valid || dupContactCheck()"
            (click)="contactTemplateRef.close(contactForm.value)"
          >
            Add Contact
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
